import { useEffect } from 'react';
import { useRevampJourney } from 'hooks/useRevampJourney';
import type { Route } from './app-routes';
import type { Route as RouteRevamp } from './app-routes-revamp';

export function usePreload(routes: (Route | RouteRevamp)[]) {
  const { isRevampJourney } = useRevampJourney();

  useEffect(() => {
    if (isRevampJourney) {
      const revampRoutes = routes as RouteRevamp[];
      revampRoutes.forEach((route) => {
        const {
          Content,
          LeftSidebar,
          RightSidebar,
          Header,
          Skyline,
          Footer,
          component
        } = route;

        [
          Content,
          LeftSidebar,
          RightSidebar,
          Header,
          Skyline,
          Footer,
          component
        ].forEach((Component) => {
          if (Component && typeof Component.preload === 'function') {
            Component.preload();
          }
        });
      });
    } else {
      const standardRoutes = routes as Route[];
      standardRoutes.forEach((route) => {
        const { component } = route;

        if (typeof component?.preload === 'function') {
          component.preload();
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
